import './header-menu-base.js';

const HeaderMenu = customElements.get('header-menu');
const SUBMENU_CLOSE_DELAY_MS = 650;

if (HeaderMenu && !HeaderMenu.prototype.__savorHoverPatched) {
  const originalDeactivate = HeaderMenu.prototype.deactivate;
  const closeTimers = new WeakMap();

  HeaderMenu.prototype.deactivate = function (event) {
    const currentTimer = closeTimers.get(this);
    if (currentTimer) {
      clearTimeout(currentTimer);
      closeTimers.delete(this);
    }

    if (!(event?.target instanceof Element)) {
      return originalDeactivate.call(this, event);
    }

    const listItem = event.target.closest('.menu-list__list-item');
    const submenu = listItem?.querySelector(':scope > [ref="submenu[]"]');
    const relatedTarget = event.relatedTarget;

    // Keep the menu open when the pointer/focus is moving from the top-level
    // country link directly into its dropdown content.
    if (relatedTarget instanceof Node && submenu?.contains(relatedTarget)) {
      return;
    }

    // Keep the dropdown open long enough to cross the visual gap between the
    // navigation link and submenu, including for slower pointer movement.
    if (event.type === 'pointerleave' || event.type === 'mouseleave') {
      const timer = setTimeout(() => {
        closeTimers.delete(this);

        const hoveredSubmenu = this.querySelector('[ref="submenu[]"]:hover');
        const hoveredMenuItem = this.querySelector('.menu-list__list-item:hover');

        if (hoveredSubmenu || hoveredMenuItem) return;
        originalDeactivate.call(this, event);
      }, SUBMENU_CLOSE_DELAY_MS);

      closeTimers.set(this, timer);
      return;
    }

    return originalDeactivate.call(this, event);
  };

  Object.defineProperty(HeaderMenu.prototype, '__savorHoverPatched', {
    value: true,
    configurable: true,
  });
}
